import Api from './Api';
import resolve from  '../util/Configuracao';

class AcertoCoparticipacaoApi extends Api {
  async consultarTodosOsProtocolos () {
    try {
      const nomesUrl = resolve('urlConsultarNomesTodosProtocolosAcertoCoparticipacao');
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarTipos () {
    try {
      const tiposUrl = resolve('urlConsultarTiposAcertoCoparticipacao');
      const response = await this.fetch(tiposUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEstados () {
    try {
      const estadosAcertoUrl = resolve('urlConsultarEstadosAcertoCoparticipacao');
      const response = await this.fetch(estadosAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarGuias (numMatricula) {
    try {
      const guiasAcertoUrl = resolve('guiasAcertoUrl') + numMatricula;
      const response = await this.fetch(guiasAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarGuiasCarteiraPrestador (numMatricula, seqPrestador) {
    try {
      const guiasAcertoUrl = resolve('guiasAcertoUrl') + numMatricula +
      '/prestador/' + seqPrestador;
      const response = await this.fetch(guiasAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarDemonstrativos (numMatricula) {
    try {
      const demonstrativosAcertoUrl = resolve('demonstrativosAcertoUrl') + numMatricula;
      const response = await this.fetch(demonstrativosAcertoUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarProcedimentos (numProtocolo) {
    try {
      const urlConsultarProcedimentos = resolve('urlConsultarProcedimentos') +
      numProtocolo;
      const response = await this.fetch(urlConsultarProcedimentos, 'post');
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }

  async consultarAcertos (numProtocolo, numMatricula, codTipo, codEstado, numProcesso, anoProcesso, dataInicial, dataFinal, seqPrestador) {
    let acertos = [];
    let brancoAcoes = '';
    let tipoBotaoCancelamento = '';
    try {
      const acertoUrl = resolve('urlConsultarAcertosCoparticipacao') +
      numProtocolo + '/' +
      numMatricula + '/' +
      codTipo + '/' +
      codEstado + '/' +
      numProcesso + '/' +
      anoProcesso + '/' +
      dataInicial + '/' +
      dataFinal + '/' +
      seqPrestador;
      const { data } = await this.fetch(acertoUrl, 'post');
      data.map(res => {
        const { numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, codTipo, desTipo, codEstado, desEstado, txtObservacao, dtaCadastro, dtaEfeitoFinanc, numProcesso, anoProcesso, valAcertoPrestador, indCancelado, historicos, seqPrestador, procedimentos, seqDivida, arquivos, numCnpjOrigemPagto, nomPrestador, txtProcessoSei } = res;
        const numAnoProc = numProcesso + '/' + anoProcesso;
        brancoAcoes = indCancelado;
        if (codEstado === 4) {
          tipoBotaoCancelamento = 'DESFAZER';
        } else {
          if (codEstado === 1) {
            tipoBotaoCancelamento = 'CANCELAR';
          } else {
            tipoBotaoCancelamento = 'NENHUM';
          }
        }
        acertos.push(Object.values({ numProtocolo, seqBeneficiario, seqDependente, numMatricula, nomeBeneficiario, valAcerto, valAcertoPrestador, codTipo, desTipo, codEstado, desEstado, txtObservacao, dtaCadastro, dtaEfeitoFinanc, numAnoProc, indCancelado, historicos, anoProcesso, numProcesso, seqPrestador, procedimentos, seqDivida, arquivos, numCnpjOrigemPagto, nomPrestador, txtProcessoSei, tipoBotaoCancelamento, brancoAcoes }));
      });
      return acertos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarProcedimentosPagAntecipado (numMatricula, seqProcedimentosSelecionados) {
    let procedimentos = [];
    try {
      const urlConsultarProcedimentosPagAntecipado = resolve('urlConsultarProcedimentosPagAntecipado') +
      numMatricula;
      const { data } = await this.fetch(urlConsultarProcedimentosPagAntecipado, 'post', seqProcedimentosSelecionados);
      data.map(res => {
        const { seqProcedimento, codItem, desItem, codTabela, desTabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, valProcedimento, valServidor, valRestaPagar, seqDivida, carteira, nome } = res;
        let tabela = codTabela.toString() + '-' + desTabela;
        let brancoAcoes = '';
        procedimentos.push(Object.values({ seqProcedimento, carteira, nome, codItem, desItem, tabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, valProcedimento, valServidor, valRestaPagar, seqDivida, brancoAcoes }));
      });
      return procedimentos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarProcedimentosDevolucao (numMatricula, codGuia, seqProcedimentosSelecionados) {
    let procedimentos = [];
    try {
      const urlConsultarProcedimentosDevolucao = resolve('urlConsultarProcedimentosDevolucao') +
        numMatricula + '/' +
        codGuia;
      const { data } = await this.fetch(urlConsultarProcedimentosDevolucao, 'post', seqProcedimentosSelecionados);
      data.map(res => {
        const { seqProcedimento, codItem, desItem, codTabela, desTabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, valProcedimento, valServidor, carteira, nome, numCnpjOrigemPagto, dtaPagamento, indOdontologico } = res;
        let tabela = codTabela.toString() + '-' + desTabela;
        let origem = numCnpjOrigemPagto === '509968000148' ? 'Orçamento União' : 'Orçamento do Plano';
        let brancoAcoes = '';
        procedimentos.push(Object.values({ seqProcedimento, carteira, nome, codItem, desItem, tabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, dtaPagamento, origem, valProcedimento, valServidor, indOdontologico, brancoAcoes }));
      });
      return procedimentos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async consultarProcedimentosCopartCalcIncorreto (numMatricula, codGuia, numDemonstrativo, seqPrestador, seqProcedimentosSelecionados) {
    let procedimentos = [];

    try {
      const urlConsultarProcedimentosCopartCalcIncorreto = resolve('urlConsultarProcedimentosCopartCalcIncorreto') +
        numMatricula + '/' +
        codGuia + '/' +
        numDemonstrativo + '/' +
        seqPrestador;
      const { data } = await this.fetch(urlConsultarProcedimentosCopartCalcIncorreto, 'post', seqProcedimentosSelecionados);
      data.map(res => {
        const { seqProcedimento, codItem, desItem, codTabela, desTabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, valProcedimento, valServidor, seqDivida, carteira, nome, percCoparticipacao, indCopartCobradaTotal, valCoparticipacaoCalculada } = res;
        let tabela = codTabela.toString() + '-' + desTabela;
        let novoValor = 0;
        let valorAjuste = 0;
        let brancoAcoes = '';
        procedimentos.push(Object.values({ seqProcedimento, carteira, nome, codItem, desItem, tabela, seqBeneficiario, seqDependente, seqPrestador, desPrestador, codGuia, dtaProcedimento, indCopartCobradaTotal, percCoparticipacao, valProcedimento, valCoparticipacaoCalculada, valServidor, seqDivida, novoValor, valorAjuste, brancoAcoes }));
      });
      return procedimentos || [];
    } catch (error) {
      console.error(error);
    }
  }

  async incluirAcerto (acerto) {
    try {
      const urlIncluirAcerto = resolve('urlIncluirAcertoCoparticipacao');
      const response = await this.fetch(urlIncluirAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }

  async alterarAcerto (acerto) {
    try {
      const urlAlterarAcerto = resolve('urlAlterarAcertoCoparticipacao');
      const response = await this.fetch(urlAlterarAcerto, 'put', acerto);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async processarAcertoPagAntecipado (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    try {
      const urlProcessarAcerto = resolve('urlProcessarAcertoPagAntecipado') +
      numProtocolo + '/' +
      dataEfeitoFinanc + '/' +
      dtaInicio + '/' +
      dtaFim;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async processarAcertoDevolucao (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    try {
      const urlProcessarAcerto = resolve('urlProcessarAcertoDevolucao') +
      numProtocolo + '/' +
      dataEfeitoFinanc + '/' +
      dtaInicio + '/' +
      dtaFim;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async processarAcertoCobrancaIndevida (numProtocolo, dataEfeitoFinanc, dtaInicio, dtaFim) {
    try {
      const urlProcessarAcerto = resolve('urlProcessarAcertoCobrancaIndevida') +
      numProtocolo + '/' +
      dataEfeitoFinanc + '/' +
      dtaInicio + '/' +
      dtaFim;
      const response = await this.fetch(urlProcessarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async cancelarAcerto (numProtocolo, motivoCancelamento) {
    try {
      const urlCancelarAcerto = resolve('urlCancelarAcertoCopart') + numProtocolo + '/' + motivoCancelamento;
      const response = await this.fetch(urlCancelarAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async desfazerCancelamentoAcerto (numProtocolo) {
    try {
      const urlDesfazerCancelamentoAcerto = resolve('urlDesfazerCancelamentoAcertoCopart') + numProtocolo;
      const response = await this.fetch(urlDesfazerCancelamentoAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  // async analisarAcerto (numProtocolo) {
  //   let result = await this.getAcertoCoparticipacaoApi().analisarAcerto(numProtocolo);
  //   return result;
  // }
  async excluirAcerto (numProtocolo) {
    try {
      const urlExcluirAcerto = resolve('urlExcluirAcertoCoparticipacao') + numProtocolo;
      const response = await this.fetch(urlExcluirAcerto, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async anexarArquivo (numProtocolo, nomeArquivo, txtObjetoGed) {
    try {
      const urlAnexarArquivo = resolve('urlAnexarArquivo') + numProtocolo + '/' + nomeArquivo + '/' + txtObjetoGed;
      const response = await this.fetch(urlAnexarArquivo, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarArquivos (numProtocolo) {
    try {
      const consultarArquivosUrl = resolve('consultarArquivosUrl') + numProtocolo;
      const response = await this.fetch(consultarArquivosUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async deletarArquivo (codArquivo) {
    try {
      const urlDeletarArquivo = resolve('urlDeletarArquivo') + codArquivo;
      const response = await this.fetch(urlDeletarArquivo, 'put');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
}
export default AcertoCoparticipacaoApi;
